// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Optimize$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/Optimize.bs.js";
function getMeasurementId(param) {
  return Belt_Option.flatMap(Belt_Option.map(Belt_Option.flatMap(Belt_Option.map(window.maker_optimize, function (o) {
    return o.data;
  }), function (prim) {
    if (prim == null) {
      return;
    } else {
      return Caml_option.some(prim);
    }
  }), function (d) {
    return d.measurementId;
  }), function (prim) {
    if (prim == null) {
      return;
    } else {
      return Caml_option.some(prim);
    }
  });
}
function getExperiments(redirectOpt, productTypeOpt, log, param) {
  var redirect = redirectOpt !== undefined ? redirectOpt : false;
  var productType = productTypeOpt !== undefined ? productTypeOpt : /* Nav */0;
  var data = Belt_Option.flatMap(Belt_Option.map(Belt_Option.map(Belt_Option.flatMap(Belt_Option.map(window.maker_optimize, function (o) {
    return o.data;
  }), function (prim) {
    if (prim == null) {
      return;
    } else {
      return Caml_option.some(prim);
    }
  }), function (d) {
    return d.experiments;
  }), Optimize$ApiTypes.Experiment.experiments_decode), function (response) {
    if (response.TAG === /* Ok */0) {
      return response._0;
    }
  });
  if (data !== undefined) {} else {
    Curry._1(log, "no maker_optimize found");
  }
  var experiments = Belt_Array.keep(Belt_Option.getWithDefault(data, []), function (experiment) {
    var match = experiment.experimentType;
    if (redirect) {
      return match >= 2;
    } else if (match >= 2) {
      return false;
    } else {
      return experiment.product === productType;
    }
  });
  if (experiments.length !== 0) {} else {
    Curry._1(log, "no experiments found");
  }
  return experiments;
}
function getGroups(redirectOpt, productTypeOpt, log, param) {
  var redirect = redirectOpt !== undefined ? redirectOpt : false;
  var productType = productTypeOpt !== undefined ? productTypeOpt : /* Nav */0;
  var groups = Belt_Array.keep(Belt_Option.getWithDefault(Belt_Option.flatMap(Belt_Option.map(Belt_Option.map(Belt_Option.flatMap(Belt_Option.map(window.maker_optimize, function (o) {
    return o.data;
  }), function (prim) {
    if (prim == null) {
      return;
    } else {
      return Caml_option.some(prim);
    }
  }), function (d) {
    return d.groups;
  }), Optimize$ApiTypes.Group.groups_decode), function (response) {
    if (response.TAG === /* Ok */0) {
      return response._0;
    }
  }), []), function (group) {
    return Belt_Array.some(getExperiments(redirect, productType, log, undefined), function (experiment) {
      return Caml_obj.equal(experiment.groupId, Caml_option.some(group.id));
    });
  });
  if (groups.length !== 0) {} else {
    Curry._1(log, "no groups found");
  }
  return groups;
}
export { getMeasurementId, getExperiments, getGroups };
/* Optimize-ApiTypes Not a pure module */